import { Component } from '@angular/core';

@Component({
  selector: 'app-preview-footer',
  templateUrl: './preview-footer.component.html',
  styleUrls: ['./preview-footer.component.scss']
})
export class PreviewFooterComponent {}
